import { DashboardListView } from "@/lib/dashboardListScrollRestore";
import { createContext, useContext } from "react";

type DashboardListViewContextValue = {
  view: DashboardListView;
};

export const DashboardListViewContext =
  createContext<DashboardListViewContextValue | null>(null);

export function useDashboardListView(): DashboardListView {
  const ctx = useContext(DashboardListViewContext);
  return ctx?.view ?? "list";
}
